import React from 'react';
import RankChart from './RankChart';
import RadarChart from './RadarChart';
import GaugeChart from './GaugeChart';
import BarChart from './BarChart';
import MapChart from './MapChart';
import './MainDisplay.css';

const MainDisplay = () => {
  return (
    <div className="main-display">
      <div className="left-panel">
        <div className="rank-chart-container">
          <h3>综合排名排行榜</h3>
          <RankChart />
        </div>
      </div>
      
      <div className="right-panel">
        <div className="radar-gauge-container">
          <div className="radar-chart-container">
            <h3>六维能力雷达图</h3>
            <RadarChart />
          </div>
          <div className="gauge-chart-container">
            <h3>关键指标仪表盘</h3>
            <GaugeChart />
          </div>
        </div>
        
        <div className="bar-map-container">
          <div className="bar-chart-container">
            <h3>区县局指标对比</h3>
            <BarChart />
          </div>
          <div className="map-chart-container">
            <h3>福州市地图可视化</h3>
            <MapChart />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainDisplay;